/*----------------------------------------------------------
Script name:       Big Bird Carousel - Level 5
Author:            Luke Guppy
Version:           2.0
Created date:      29/01/2014
Notes:             Responsive fading carousel with auto
----------------------------------------------------------*/
var bigBird = function (options) {
    'use strict';
    /// <summary>
    /// Builds a BigBird carousel with given options or uses defaults. Runs Init(), builds and binds interactions to controls.
    /// </summary>
    /// <param name="options" type="object">Options object can contain wrap: [selector string], interval: [number], speed: [number], start: [number], itemsDisplayed: [number], callBack: [function]
    /// </param>
    var self = this;
    self.Opt = new bigBird.Opt(options);
    var fadeItem = function (item) {
        /// <summary>
        /// Fades out the supplied item, removes it, checks/runs RunAuto, rebinds controls, checks/runs CallBack
        /// </summary>
        /// <param name="item" type="jqObject">Old item to remove</param>
        item.fadeOut(self.Opt.Speed, function () {
            item.remove();
            if (self.Opt.Auto) {
                RunAuto();
            };
            BindControls();
            if (self.Opt.CallBack) {
                self.Opt.CallBack(self.Opt);
            }
        });
    };
    var GoToNext = function () {
        /// <summary>
        /// Increments self.Opt.CurrentInt and transitions to the next item 
        /// </summary>
        self.Opt.Controls.find('.active').removeClass('active');
        var target = 0;
        if (self.Opt.CurrentInt != self.Opt.Items.length - 1) {
            target = self.Opt.CurrentInt + 1;
        }
        self.Opt.CurrentInt = target;
        $(self.Opt.Controls.Btns[self.Opt.CurrentInt]).addClass('active');
        UpdateViewport(target);
    };
    var BindControls = function () {
        /// <summary>
        /// Binds the UpdateViewport function to the carousel controls
        /// </summary>
        self.Opt.Controls.find("ul a").off().on("click.slide", function () {
            RunAuto(true);
            self.Opt.Controls.find('.active').removeClass('active');
            $(this).parent().addClass('active');
            self.Opt.Controls.find("a").off().on("click.blank", function () {
                return false;
            });
            var target = this.href.split("#")[1];
            target = parseInt(target.replace(/^\D+/g, ''));
            UpdateViewport(target);
            return false;
        });
    };
    var BuildControls = function () {
        /// <summary>
        /// Build carousel controls and bind events, HTML structure is defined within this function
        /// </summary>
        self.Opt.Wrap.append("<nav class='controls'><ul></ul></nav>");
        self.Opt.Controls = self.Opt.Wrap.find(".controls");
        for (var i = 0; i < self.Opt.Items.length; i++) {
            if (i == self.Opt.CurrentInt) {
                self.Opt.Controls.find('ul').append("<li class='active'><a href='#target" + i + "'>Carousel item " + (i + 1) + "</a></li>");
            }
            else {
                self.Opt.Controls.find('ul').append("<li><a href='#target" + i + "'>Carousel item " + (i + 1) + "</a></li>");
            }
        };
        self.Opt.Controls.Btns = self.Opt.Controls.find('> ul > li');
    };
    var RunAuto = function (stop) {
        /// <summary>
        /// clears then sets the timeout - if stop is set to true clears the timeout and disables auto option
        /// </summary>
        /// <param name="stop" type="boolean"></param>
        if (stop) {
            self.Opt.Auto = false;
            clearTimeout(self.Opt.AutoRun);
        }
        else {
            clearTimeout(self.Opt.AutoRun);
            self.Opt.AutoRun = setTimeout(function () { GoToNext(); }, self.Opt.Interval);
        }
    };
    var UpdateViewport = function (target) {
        /// <summary>
        /// New CurrentItem defined, cloned and added to viewport / fade animation called to remove old item
        /// </summary>
        /// <param name="target" type="string">String containing trget index value</param>
        self.Opt.CurrentItem = $(self.Opt.Items[target]);
        self.Opt.Viewport.prepend(self.Opt.CurrentItem.clone());
        var oldItem = self.Opt.Viewport.find("li:last-child");
        fadeItem(oldItem);
    };
    var BuildViewport = function (item) {
        /// <summary>
        /// Sets the previous and next items from the current item, Builds the carousel viewport to show the carousel items and posistions
        /// </summary>
        self.Opt.Wrap.prepend("<div class='viewport'><ul></ul></div>");
        self.Opt.Viewport = self.Opt.Wrap.find(".viewport > ul");
        self.Opt.Viewport.append(item.clone());
    };
    var Init = (function () {
        /// <summary>
        /// Initialise the carousel, hide the carousel list, se the start object, build the viewport and controls
        /// </summary>
        self.Opt.ItemList = self.Opt.Wrap.find("> ul");
        self.Opt.ItemList.hide();
        self.Opt.Items = self.Opt.ItemList.find("> li");
        self.Opt.CurrentItem = $(self.Opt.Items[self.Opt.Start]);
        self.Opt.CurrentInt = self.Opt.Start;
        BuildControls();
        BindControls();
        BuildViewport($(self.Opt.Items[self.Opt.Start]));
        if (self.Opt.Auto) {
            RunAuto();
        };
    })();
};
bigBird.Opt = function (options) {
    'use strict';
    /// <summary>
    /// Build options object from given options or use defaults
    /// </summary>
    /// <param name="options" type="object">Options object can contain wrap: [selector string], interval: [number], speed: [number], start: [number], itemsDisplayed: [number], callBack: [function]
    options && options.wrap ? this.Wrap = $(options.wrap) : this.Wrap = $("#carousel");
    options && options.speed ? this.Speed = options.speed : this.Speed = 1000;
    options && options.interval ? this.Interval = options.interval : this.Interval = 5000;
    options && options.auto ? this.Auto = options.auto : this.Auto = true;
    options && options.start ? this.Start = options.start : this.Start = 0;
    options && options.callBack ? this.CallBack = options.callBack : this.CallBack = '';
};